module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_iterators.js
// module id = 42
// module chunks = 0